// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"YP","selections":"ZP","pillsDesktopSearchMenu":"_P"};